import { Flex, ProgressCircle, Tabs } from 'components'
import { useWorkspace } from 'components/providers'
import { useState } from 'react'
import { useParams, useSearchParams } from 'react-router'
import { OnTheGoMemberAnalytics, OnTheGoMemberBanner, OnTheGoMemberLeads } from '../components'

type View = 'analytics' | 'sessions'

export default function OnTheGoMemberPage() {
  const { id: memberId } = useParams<{ id: string }>()
  const { status, workspace } = useWorkspace()
  const [searchParams, setSearchParams] = useSearchParams()
  const [shrinkBanner, setShrinkBanner] = useState(false)

  const view = (searchParams.get('view') || 'sessions') as View

  if (status !== 'success' || !workspace) {
    return (
      <Flex justify="center" maxW="100%" p={20}>
        <ProgressCircle isIndeterminate />
      </Flex>
    )
  }

  if (!memberId) return null

  return (
    <Flex
      direction="column"
      gap={2}
      overflow="hidden"
      pb={3}
      pr={{ base: 0, md: 5 }}
      pt={{ base: 0, md: 4 }}
    >
      {!shrinkBanner && <OnTheGoMemberBanner />}
      <Tabs
        display="flex"
        flexDirection="column"
        overflow="hidden"
        items={[
          {
            children: (
              <OnTheGoMemberLeads
                shrinkBanner={shrinkBanner}
                updateShrinkBanner={setShrinkBanner}
              />
            ),
            label: 'Sessions',
            labelProps: {
              onClick: () => setSearchParams({ view: 'sessions' }),
              py: 3,
              textStyle: 'bodyMedium',
            },
            mt: 4,
            overflow: 'hidden',
            value: 'sessions',
          },
          {
            children: <OnTheGoMemberAnalytics />,
            label: 'Analytics',
            labelProps: {
              onClick: () => setSearchParams({ view: 'analytics' }),
              py: 3,
              textStyle: 'bodyMedium',
            },
            mt: 0,
            overflowY: 'auto',
            value: 'analytics',
          },
        ]}
        lazyMount
        mt={0}
        value={view}
      />
    </Flex>
  )
}
